module.exports = __webpack_public_path__ + "img/ChaseBank.8c415794.svg";